exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit_table_input[data-v-27c40852]  .el-input{width:auto}", ""]);

// exports
